import { ROLES } from "../../auth/constants";

const config = {
  SITE: 'safety_nonprod',
  LABEL: 'Safety',
  SITE_ID: 'groups.coca-cola.com,18f2d0a2-e373-4c4a-b16f-64378e8812b8,fceaa800-42ab-44b0-8014-8f7a0d40e45c',
  PAGES_LIST_ID: '80848ccd-dbe1-42f2-8b31-1af655fc2940',
  DOCUMENTS_LIST_ID: 'e1031f5f-9507-444b-84a6-690bd6630e4c',
  SITE_ASSETS_DRIVE_ID: 'b!otDyGHPjSkyxb2Q3jogSuACo6vyrQrBEgBSPeg1A5FzsV0ws6YoyQZHW7ihBYUCM',
  DOCUMENTS_DRIVE_ID: 'b!otDyGHPjSkyxb2Q3jogSuACo6vyrQrBEgBSPeg1A5FxfHwPhB5VLRISmaQvWYw5M',
  NEWS_TEMPLATE_ID: 'ac8be6d2-658a-42ab-bb22-bccec11c8d47',
  SETTINGS_FILE_PATH: 'Settings/HubSettings.json',
  OPT_OUT_FILE_PATH: 'Settings/EmailOptOut.txt',
  MANAGER_ROLES: [ROLES.QSE_SAFETY_MANAGER],
  VIVA_COMMUNITY_ID: undefined
}

export default config